// ThemeSync.jsx
import { useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { selectUsers } from "../store/usersSlice";
import { ThemeContext } from "../../ThemeContext";
import { applyUserTheme } from "../../firebase";

export default function ThemeSync() {
  const { currentUser } = useSelector(selectUsers);
  const { setTheme } = useContext(ThemeContext);

  useEffect(() => {
    if (!currentUser) return;
    const loadTheme = async () => {
      const savedTheme = await applyUserTheme(currentUser.id);
      setTheme(savedTheme);
    };
    loadTheme();
  }, [currentUser, setTheme]);

  return null;
}
